import React, { useState, useRef, useEffect } from 'react'
import Cookies from 'universal-cookie'
import { useNavigate, Link, useLocation, NavLink } from 'react-router-dom'
import moment from 'moment'
import AsyncSelect from 'react-select/async'
import FeatherIcon from 'feather-icons-react'
// Local Import
import { ChangeUserCompany, FilterCompanies } from '../AdminAPI/intranet'
import { withContext } from '../context/withContext'
import { ViewBrandAPI } from '../API/core'
import { canAccessPropertyDuplication } from '../Pages/Properties/duplication/utils'

const cookies = new Cookies()

function classNames(...classes) {
	return classes.filter(Boolean).join(' ')
}

function Topbar(props) {
	const navigate = useNavigate()
	const location = useLocation()
	const user = props.context.user
	const brand = props.context.brand
	const permits = props.context.user.permits
	const canAccessDuplication = canAccessPropertyDuplication(user)
	const [datacompanies, setCompanies] = useState([])
	const [companydefault, setCompanyDefault] = useState({
		value: permits.company,
		label: user.company,
	})
	const [debounce, setDebounce] = useState(0)
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
	const [userMenuOpen, setUserMenuOpen] = useState(false)
	const [locationsMenuOpen, setLocationsMenuOpen] = useState(false)
	const [sitesMenuOpen, setSitesMenuOpen] = useState(false)
	const [propertiesMenuOpen, setPropertiesMenuOpen] = useState(false)
	const [reportsMenuOpen, setReportsMenuOpen] = useState(false)
	const [brikMenuOpen, setBrikMenuOpen] = useState(false)
	const userMenuRef = useRef(null)
	const locationsMenuRef = useRef(null)
	const sitesMenuRef = useRef(null)
	const propertiesMenuRef = useRef(null)
	const reportsMenuRef = useRef(null)
	const brikMenuRef = useRef(null)

	// Navigation items from sidebar
	const navigation = [
		{ name: 'Escritorio', href: '/', exact: true },
		{ name: 'Compañías', href: '/companies?sort=-timestamp&page=1' },
		{ name: 'Usuarios', href: '/users?page=1&sort=-date_joined' },
		{
			name: 'Reportes',
			isDropdown: true,
			dropdownKey: 'reports',
			children: [
				{ name: 'Suscripciones', href: '/reports/subscriptions' },
				{ name: 'Cancelaciones', href: '/reports/cancellations' },
				{ name: 'Cancelaciones / Tabla', href: '/reports/cancellations-table' },
				{ name: 'Brik', href: '/reports/brik' },
				{ name: 'Inbox', href: '/reports/inbox' },
				{ name: 'Facebook Leads', href: '/reports/facebook-leads' },
				{ name: 'Compañías', href: '/reports/companies' },
				{ name: 'Usuarios', href: '/reports/users' },
				{ name: 'Bancos', href: '/reports/banks' },
			],
		},
		{
			name: 'Brik',
			isDropdown: true,
			dropdownKey: 'brik',
			children: [
				{ name: 'Configuración global', href: '/brik/global-config' },
				{ name: 'Sesiones', href: '/brik/sessions' },
				{ name: 'Support Copilot', href: '/brik/support-copilot' },
				{ name: 'Reporte', href: '/reports/brik' },
			],
		},
		{
			name: 'Ubicaciones',
			isDropdown: true,
			dropdownKey: 'locations',
			children: [
				{ name: 'AlterEstate', href: '/locations' },
				{ name: 'MaxCore', href: '/locations-remax' },
			],
		},
		{
			name: 'Propiedades',
			isDropdown: true,
			dropdownKey: 'properties',
			children: [
				{ name: 'Propiedades', href: '/properties' },
				...(canAccessDuplication
					? [
							{ name: 'Duplicar propiedades', href: '/properties/duplicate' },
							{ name: 'Migraciones', href: '/properties/duplicate/migrations' },
						]
					: []),
				{ name: 'Mapa', href: '/property-map' },
				{ name: 'Reportes Trexo', href: '/trexo-reports' },
			],
		},
		{
			name: 'Sitios Web',
			isDropdown: true,
			dropdownKey: 'sites',
			children: [
				{ name: 'Sites', href: '/sites' },
				{ name: 'Site Configs', href: '/site-configs' },
			],
		},
	]

	const isActive = (item) => {
		if (item.exact) {
			return location.pathname === item.href
		}
		if (item.isDropdown && item.children) {
			return item.children.some((child) => location.pathname.startsWith(child.href.split('?')[0]))
		}
		return location.pathname.startsWith(item.href.split('?')[0])
	}

	// Close menus when clicking outside
	useEffect(() => {
		function handleClickOutside(event) {
			if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
				setUserMenuOpen(false)
			}
			if (locationsMenuRef.current && !locationsMenuRef.current.contains(event.target)) {
				setLocationsMenuOpen(false)
			}
			if (sitesMenuRef.current && !sitesMenuRef.current.contains(event.target)) {
				setSitesMenuOpen(false)
			}
			if (propertiesMenuRef.current && !propertiesMenuRef.current.contains(event.target)) {
				setPropertiesMenuOpen(false)
			}
			if (reportsMenuRef.current && !reportsMenuRef.current.contains(event.target)) {
				setReportsMenuOpen(false)
			}
			if (brikMenuRef.current && !brikMenuRef.current.contains(event.target)) {
				setBrikMenuOpen(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return () => document.removeEventListener('mousedown', handleClickOutside)
	}, [])

	// Functions
	const handleLogout = async () => {
		try {
			cookies.remove('token')
			cookies.remove('company')
			localStorage.removeItem('pipeline_filters')
			let response = await ViewBrandAPI(window.location.host)
			let state = {
				token: null,
				company: null,
				collapseSidebar: cookies.get('toggle'),
				isLogged: false,
				isActive: false,
				brand: response.data,
				user: {},
				settings: {},
				filters: {},
			}
			navigate('/')
			props.updateContextVal(state)
		} catch (error) {
			console.log(error)
		}
	}

	const loadData = (inputValue, callback) => {
		clearTimeout(debounce)
		setDebounce(
			setTimeout(() => {
				return FilterCompanies(`name=${inputValue}&sort=name`).then((response) => {
					const companies = response.data.results
					let newArray = []
					for (let x in companies) {
						newArray.push({
							value: companies[x].name.replace(/\W/g, ''),
							label: (
								<div className="tw-py-1">
									<p className="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-100">
										{companies[x].name}
									</p>
									<div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mt-1">
										<small className="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
											Registro: {moment(companies[x].timestamp).format('DD/MM/YYYY')}
										</small>
										<span
											className={classNames(
												'tw-text-xs tw-font-medium tw-px-2 tw-py-0.5 tw-rounded-md',
												companies[x].is_active
													? 'tw-bg-green-100 tw-text-green-800 dark:tw-bg-green-900/30 dark:tw-text-green-400'
													: 'tw-bg-yellow-100 tw-text-yellow-800 dark:tw-bg-yellow-900/30 dark:tw-text-yellow-400'
											)}>
											{companies[x].is_active ? 'Activo' : 'Inactivo'}
										</span>
									</div>
								</div>
							),
							data: companies[x],
						})
					}
					return callback(newArray)
				})
			}, 500)
		)
	}

	const handleChangeCompany = async (company_new) => {
		if (!company_new) return

		const uid = props.context.user.uid
		let dataContext = { ...props.context }
		dataContext.company = company_new.uid
		dataContext.user.company = company_new.value

		try {
			await ChangeUserCompany({ company: company_new.data.uid }, uid)
			props.updateContextVal(dataContext)
		} catch (error) {
			alert(error, 'error al editar el usuario')
		}
	}

	const userNavigation = [
		{
			name: 'Ajustes',
			href: '/settings/account',
			icon: 'settings',
			onClick: null,
		},
		{
			name: 'Salir',
			href: '#',
			icon: 'log-out',
			onClick: handleLogout,
		},
	]

	const primaryColor = '#26424B'

	return (
		<nav
			className="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-40 tw-bg-green-600 dark:tw-bg-green-800 tw-shadow-lg"
			style={{ backgroundColor: primaryColor }}>
			<div className="container-fluid">
				<div className="tw-flex tw-h-16 tw-items-center tw-justify-between">
					{/* Left side */}
					<div className="tw-flex tw-items-center">
						{/* Logo */}
						<div className="tw-shrink-0">
							{brand?.favicon || brand?.logo ? (
								<img
									alt={brand?.name || 'Logo'}
									src={brand.favicon || brand.logo}
									className="tw-h-8 tw-w-auto tw-filter tw-brightness-0 tw-invert"
								/>
							) : (
								<div className="tw-h-8 tw-w-8 tw-rounded-lg tw-bg-white/20 tw-flex tw-items-center tw-justify-center">
									<span className="tw-text-lg tw-font-bold tw-text-white">A</span>
								</div>
							)}
						</div>
						{/* Navigation - Desktop */}
						<div className="tw-hidden md:tw-block">
							<div className="tw-ml-10 tw-flex tw-items-baseline tw-space-x-4">
								{navigation.map((item) => {
									const active = isActive(item)

									if (item.isDropdown) {
										// Determine which dropdown state/ref to use
										let menuOpen, setMenuOpen, menuRef
										if (item.dropdownKey === 'sites') {
											menuOpen = sitesMenuOpen
											setMenuOpen = setSitesMenuOpen
											menuRef = sitesMenuRef
										} else if (item.dropdownKey === 'properties') {
											menuOpen = propertiesMenuOpen
											setMenuOpen = setPropertiesMenuOpen
											menuRef = propertiesMenuRef
										} else if (item.dropdownKey === 'reports') {
											menuOpen = reportsMenuOpen
											setMenuOpen = setReportsMenuOpen
											menuRef = reportsMenuRef
										} else if (item.dropdownKey === 'brik') {
											menuOpen = brikMenuOpen
											setMenuOpen = setBrikMenuOpen
											menuRef = brikMenuRef
										} else {
											// Default: locations
											menuOpen = locationsMenuOpen
											setMenuOpen = setLocationsMenuOpen
											menuRef = locationsMenuRef
										}

										return (
											<div key={item.name} className="tw-relative" ref={menuRef}>
												<button
													type="button"
													onClick={() => setMenuOpen(!menuOpen)}
													className={classNames(
														active
															? 'tw-bg-green-700 tw-text-white dark:tw-bg-green-950/40'
															: 'tw-text-white hover:tw-bg-green-500/75 dark:hover:tw-bg-green-700/75',
														'tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition-colors tw-flex tw-items-center tw-gap-1'
													)}>
													{item.name}
													<FeatherIcon
														icon="chevron-down"
														className={classNames(
															'tw-h-4 tw-w-4 tw-transition-transform',
															menuOpen ? 'tw-rotate-180' : ''
														)}
													/>
												</button>
												{menuOpen && (
													<div className="tw-absolute tw-left-0 tw-z-10 tw-mt-2 tw-w-52 tw-origin-top-left tw-rounded-md tw-bg-white tw-py-1 tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 dark:tw-bg-gray-800 dark:tw-ring-white/10">
														{item.children.map((child) => (
															<NavLink
																key={child.name}
																to={child.href}
																onClick={() => setMenuOpen(false)}
																className={({ isActive: linkActive }) =>
																	classNames(
																		linkActive
																			? 'tw-bg-gray-100 tw-text-gray-900 dark:tw-bg-white/10 dark:tw-text-white'
																			: 'tw-text-gray-700 hover:tw-bg-gray-50 dark:tw-text-gray-200 dark:hover:tw-bg-white/5',
																		'tw-block tw-px-4 tw-py-2 tw-text-sm'
																	)
																}>
																{child.name}
															</NavLink>
														))}
													</div>
												)}
											</div>
										)
									}

									return (
										<NavLink
											key={item.name}
											to={item.href}
											className={classNames(
												active
													? 'tw-bg-green-700 tw-text-white dark:tw-bg-green-950/40'
													: 'tw-text-white hover:tw-bg-green-500/75 dark:hover:tw-bg-green-700/75',
												'tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition-colors'
											)}>
											{item.name}
										</NavLink>
									)
								})}
							</div>
						</div>
					</div>

					{/* Right side - Desktop */}
					<div className="tw-hidden md:tw-block">
						<div className="tw-ml-4 tw-flex tw-items-center md:tw-ml-6 tw-gap-4">
							{/* Company Selector */}
							<div className="tw-min-w-[200px]">
								<AsyncSelect
									classNamePrefix="react-select"
									loadOptions={loadData}
									defaultOptions={datacompanies}
									defaultValue={companydefault || 'No seleccionado'}
									placeholder="Cambiar de compañía"
									onChange={handleChangeCompany}
									styles={{
										control: (base) => ({
											...base,
											backgroundColor: 'white',
											borderColor: 'rgba(255, 255, 255, 0.2)',
											minHeight: '36px',
										}),
										menu: (base) => ({
											...base,
											zIndex: 9999,
										}),
									}}
									theme={(theme) => ({
										...theme,
										borderRadius: 8,
										colors: {
											...theme.colors,
											primary: primaryColor,
											primary25: `${primaryColor}25`,
										},
									})}
								/>
							</div>

							{/* User menu */}
							<div className="tw-relative tw-ml-3" ref={userMenuRef}>
								<button
									type="button"
									onClick={() => setUserMenuOpen(!userMenuOpen)}
									className="tw-relative tw-flex tw-max-w-xs tw-items-center tw-rounded-full tw-focus:tw-outline-none tw-focus:tw-ring-2 tw-focus:tw-ring-white tw-focus:tw-ring-offset-2 tw-focus:tw-ring-offset-green-600">
									<span className="tw-absolute -tw-inset-1.5" />
									<span className="tw-sr-only">Abrir menú de usuario</span>
									{user.avatar ? (
										<img
											alt=""
											src={user.avatar}
											className="tw-size-8 tw-rounded-full tw-outline tw--outline-offset-1 tw-outline-white/10"
										/>
									) : (
										<div className="tw-size-8 tw-rounded-full tw-bg-white/20 tw-flex tw-items-center tw-justify-center tw-outline tw--outline-offset-1 tw-outline-white/10">
											<span className="tw-text-sm tw-font-bold tw-text-white">
												{user.first_name?.[0]?.toUpperCase() ||
													user.email?.[0]?.toUpperCase() ||
													'U'}
											</span>
										</div>
									)}
								</button>

								{/* User dropdown menu */}
								{userMenuOpen && (
									<div className="tw-absolute tw-right-0 tw-z-10 tw-mt-2 tw-w-48 tw-origin-top-right tw-rounded-md tw-bg-white tw-py-1 tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-transition-all dark:tw-bg-gray-800 dark:tw-ring-white/10">
										<div className="tw-border-b tw-border-gray-200 tw-px-4 tw-py-3 dark:tw-border-gray-700">
											<p className="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
												{user.first_name} {user.last_name}
											</p>
											{user.position && (
												<p className="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-truncate">
													{user.position}
												</p>
											)}
										</div>
										{userNavigation.map((item) => (
											<Link
												key={item.name}
												to={item.href}
												onClick={(e) => {
													if (item.onClick) {
														e.preventDefault()
														item.onClick()
													}
													setUserMenuOpen(false)
												}}
												className="tw-flex tw-items-center tw-gap-x-2 tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-100 dark:tw-text-gray-200 dark:hover:tw-bg-white/5">
												<FeatherIcon icon={item.icon} className="tw-h-4 tw-w-4" />
												{item.name}
											</Link>
										))}
									</div>
								)}
							</div>
						</div>
					</div>

					{/* Mobile menu button */}
					<div className="-tw-mr-2 tw-flex md:tw-hidden">
						<button
							type="button"
							onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
							className="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-bg-indigo-600 tw-p-2 tw-text-indigo-200 hover:tw-bg-indigo-500/75 hover:tw-text-white focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white focus:tw-ring-offset-2 focus:tw-ring-offset-indigo-600 dark:tw-bg-indigo-800 dark:hover:tw-bg-indigo-700/75">
							<span className="tw-absolute -tw-inset-0.5" />
							<span className="tw-sr-only">Abrir menú principal</span>
							{mobileMenuOpen ? (
								<FeatherIcon icon="x" className="tw-block tw-h-6 tw-w-6" />
							) : (
								<FeatherIcon icon="menu" className="tw-block tw-h-6 tw-w-6" />
							)}
						</button>
					</div>
				</div>
			</div>

			{/* Mobile menu */}
			{mobileMenuOpen && (
				<div className="md:tw-hidden">
					<div className="tw-space-y-1 tw-px-2 tw-pt-2 tw-pb-3 sm:tw-px-3">
						{/* Mobile navigation */}
						{navigation.map((item) => {
							const active = isActive(item)

							if (item.isDropdown) {
								// Determine which dropdown state to use for mobile
								let menuOpen, setMenuOpen
								if (item.dropdownKey === 'sites') {
									menuOpen = sitesMenuOpen
									setMenuOpen = setSitesMenuOpen
								} else if (item.dropdownKey === 'properties') {
									menuOpen = propertiesMenuOpen
									setMenuOpen = setPropertiesMenuOpen
								} else if (item.dropdownKey === 'reports') {
									menuOpen = reportsMenuOpen
									setMenuOpen = setReportsMenuOpen
								} else if (item.dropdownKey === 'brik') {
									menuOpen = brikMenuOpen
									setMenuOpen = setBrikMenuOpen
								} else {
									menuOpen = locationsMenuOpen
									setMenuOpen = setLocationsMenuOpen
								}

								return (
									<div key={item.name}>
										<button
											type="button"
											onClick={() => setMenuOpen(!menuOpen)}
											className={classNames(
												active
													? 'tw-bg-green-700 tw-text-white dark:tw-bg-green-950/40'
													: 'tw-text-white hover:tw-bg-green-500/75 dark:hover:tw-bg-green-700/75',
												'tw-w-full tw-flex tw-items-center tw-justify-between tw-rounded-md tw-px-3 tw-py-2 tw-text-base tw-font-medium'
											)}>
											{item.name}
											<FeatherIcon
												icon="chevron-down"
												className={classNames(
													'tw-h-4 tw-w-4 tw-transition-transform',
													menuOpen ? 'tw-rotate-180' : ''
												)}
											/>
										</button>
										{menuOpen && (
											<div className="tw-ml-4 tw-mt-1 tw-space-y-1">
												{item.children.map((child) => (
													<NavLink
														key={child.name}
														to={child.href}
														onClick={() => {
															setMenuOpen(false)
															setMobileMenuOpen(false)
														}}
														className={({ isActive: linkActive }) =>
															classNames(
																linkActive
																	? 'tw-bg-green-800 tw-text-white dark:tw-bg-green-950/60'
																	: 'tw-text-green-100 hover:tw-bg-green-600/75 dark:hover:tw-bg-green-800/75',
																'tw-block tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-font-medium'
															)
														}>
														{child.name}
													</NavLink>
												))}
											</div>
										)}
									</div>
								)
							}

							return (
								<NavLink
									key={item.name}
									to={item.href}
									onClick={() => setMobileMenuOpen(false)}
									className={classNames(
										active
											? 'tw-bg-green-700 tw-text-white dark:tw-bg-green-950/40'
											: 'tw-text-white hover:tw-bg-green-500/75 dark:hover:tw-bg-green-700/75',
										'tw-block tw-rounded-md tw-px-3 tw-py-2 tw-text-base tw-font-medium'
									)}>
									{item.name}
								</NavLink>
							)
						})}
						{/* Mobile company selector */}
						<div className="tw-mt-4">
							<AsyncSelect
								classNamePrefix="react-select"
								loadOptions={loadData}
								defaultOptions={datacompanies}
								defaultValue={companydefault || 'No seleccionado'}
								placeholder="Cambiar de compañía"
								onChange={handleChangeCompany}
								styles={{
									control: (base) => ({
										...base,
										backgroundColor: 'white',
										borderColor: 'rgba(255, 255, 255, 0.2)',
									}),
									menu: (base) => ({
										...base,
										zIndex: 9999,
									}),
								}}
								theme={(theme) => ({
									...theme,
									borderRadius: 8,
									colors: {
										...theme.colors,
										primary: primaryColor,
									},
								})}
							/>
						</div>
					</div>
					<div className="tw-border-t tw-border-green-700 tw-pt-4 tw-pb-3 dark:tw-border-green-800">
						<div className="tw-flex tw-items-center tw-px-5">
							<div className="tw-shrink-0">
								{user.avatar ? (
									<img
										alt=""
										src={user.avatar}
										className="tw-size-10 tw-rounded-full tw-outline tw--outline-offset-1 tw-outline-white/10"
									/>
								) : (
									<div className="tw-size-10 tw-rounded-full tw-bg-white/20 tw-flex tw-items-center tw-justify-center tw-outline tw--outline-offset-1 tw-outline-white/10">
										<span className="tw-text-base tw-font-bold tw-text-white">
											{user.first_name?.[0]?.toUpperCase() ||
												user.email?.[0]?.toUpperCase() ||
												'U'}
										</span>
									</div>
								)}
							</div>
							<div className="tw-ml-3">
								<div className="tw-text-base tw-font-medium tw-text-white">
									{user.first_name} {user.last_name}
								</div>
								{user.email && (
									<div className="tw-text-sm tw-font-medium tw-text-green-300">{user.email}</div>
								)}
							</div>
						</div>
						<div className="tw-mt-3 tw-space-y-1 tw-px-2">
							{userNavigation.map((item) => (
								<Link
									key={item.name}
									to={item.href}
									onClick={(e) => {
										if (item.onClick) {
											e.preventDefault()
											item.onClick()
										}
										setMobileMenuOpen(false)
									}}
									className="tw-flex tw-items-center tw-gap-x-2 tw-block tw-rounded-md tw-px-3 tw-py-2 tw-text-base tw-font-medium tw-text-white hover:tw-bg-green-500/75 dark:hover:tw-bg-green-700/75">
									<FeatherIcon icon={item.icon} className="tw-h-5 tw-w-5" />
									{item.name}
								</Link>
							))}
						</div>
					</div>
				</div>
			)}
		</nav>
	)
}

export default withContext(Topbar)
